import { classnames } from '@aibees/shared/utils';
import { memo, useEffect } from 'react';
import { useSearchListCardStore } from '../../store';
import { config } from './config';
import { browseApi } from './mock-data';
import * as Styled from './styles';
import * as SX from './sx';
import type { EnrichTableProps as Props } from './types';

export const EnrichTable = memo(({ className }: Props) => {
  const { setEmpty, setIsLoading } = useSearchListCardStore();

  useEffect(() => {
    setEmpty(browseApi.data?.empty);
    setIsLoading(browseApi.isLoading);
  }, [browseApi.data?.empty, browseApi.isLoading]);

  return (
    <Styled.Wrapper
      className={classnames('EnrichTable', className)}
      sx={SX.root}
      config={{
        ...config,
        browseApi: {
          data: browseApi.data?.content.slice(0, 4),
          isLoading: browseApi.isLoading,
        },
      }}
    />
  );
});

EnrichTable.displayName = 'EnrichTable';
